import React from 'react';
export default ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31.175"
    height="22.7"
    viewBox="0 0 31.175 22.7"
    className={className}
  >
    <g id="noun_delivery_2964602" transform="translate(-4.65 -17.164)">
      <path
        d="M33.383,25.033A3.127,3.127,0,0,0,30.571,23.3H25.292V19.764a2.252,2.252,0,0,0-2.25-2.25H10.628a2.252,2.252,0,0,0-2.25,2.25v.746H9.662v-.746a.967.967,0,0,1,.966-.966H23.042a.967.967,0,0,1,.966.966V35.515h-6.6a3.356,3.356,0,0,0-6.588,0H8.007a.642.642,0,1,0,0,1.284h2.814a3.356,3.356,0,0,0,6.588,0h8.7a3.356,3.356,0,0,0,6.588,0h2.138a.642.642,0,0,0,.642-.642V29.368a.64.64,0,0,0-.068-.287ZM14.115,38.23a2.074,2.074,0,1,1,2.074-2.074,2.074,2.074,0,0,1-2.074,2.074ZM30.571,24.579a1.85,1.85,0,0,1,1.664,1.028l1.956,3.912-.808-1.264H25.292V24.579h5.279ZM29.4,38.23a2.074,2.074,0,1,1,2.073-2.074A2.074,2.074,0,0,1,29.4,38.23Zm3.294-2.715a3.356,3.356,0,0,0-6.588,0h-.814V29.368l8.9.152v6ZM6.807,23.708a.642.642,0,0,1,.642-.642h9.187a.642.642,0,1,1,0,1.284H7.449a.642.642,0,0,1-.642-.642ZM5,27.195a.642.642,0,0,1,.642-.642h9.3a.642.642,0,1,1,0,1.284h-9.3A.642.642,0,0,1,5,27.195Zm10.589,3.486a.642.642,0,0,1-.642.642h-6.6a.642.642,0,0,1,0-1.284h6.6a.642.642,0,0,1,.642.642Z"
        fill="#b5b5b5"
        stroke="#b5b5b5"
        strokeWidth="0.7"
      />
    </g>
  </svg>
);
